const Util = {}

/**
 * 是否包含元素
 *
 * @param {*} element  指定元素
 * @param {*} target  目标对象，Array、String
 */
Util.contains = function(element, target) {
    return target.indexOf(element) >= 0
}

/**
 * 反转字符串
 *
 * @param {String} str
 */
Util.reverse = function(str) {
    return str
        .split('')
        .reverse()
        .join('')
}

/**
 * 笛卡尔算法
 */
Util.cartesian = function(arr) {
    return arr.reduce(
        function(a, b) {
            return a
                .map(function(x) {
                    return b.map(function(y) {
                        return x.concat(y)
                    })
                })
                .reduce(function(a, b) {
                    return a.concat(b)
                }, [])
        },
        [[]]
    )
}

export default Util
